module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/Headrest Screen Camera Module-4K (32MP).38678e31.png";